/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-03-16 10:52:49
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-07-05 11:22:03
 * @FilePath: /unifyxp-v2-store-portal/src/layout/SalesChannelProductsLayout/index.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import React from 'react';
import { useSelector } from 'react-redux';
import styles from './style.module.less';
import { menuArray } from '@/src/config/SiderConfig/SalesChannelProductSiderConfig';
import { PageStructure, Trigger } from 'src/layout/Components';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
import SalesChannelHOC from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import {
  useFetchSalesChannel,
  //useClearSalesChannel,
} from 'src/constrains/SalesChannelHOC/useSalesChannel';

const SalesChannelProductsLayout = (props) => {
  const { __isCurrentSalesChannel: isCurrent } = props;
  useFetchSalesChannel({ forceUpdate: true, uuidKey: 'saleChannelUuid' });
  React.useEffect(() => {
    return () => {
      //useClearSalesChannel();
    };
  }, []);
  // const { extraHeaderComponent, extraHeaderHeight }=props;
  const collapse = useSelector(
    (state: any) => state.mainLayout.isSiderCollapsed,
  );
  const extraHeaderHeight = 80;
  return (
    <PageStructure
      trigger={<Trigger open={!collapse} />}
      menuArray={menuArray}
      siderClassName={styles.trigger}
      extraHeader={{ extraHeaderHeight: isCurrent ? extraHeaderHeight : 0 }}>
      {isCurrent && props.children}
    </PageStructure>
  );
};
export default SalesChannelHOC(SalesChannelProductsLayout, {
  type: EnumMultiLanguageType.SalesChannelProduct,
  saleChannelUuidKey: 'saleChannelUuid',
});
